import { FC } from "react";
import { Stack } from "@mui/material";
import { CommitmentUtilizationWidgetHeaderInfoProps } from "@/components/pages/dashboard/components/widgets/commitment-utlization/components/header/CommitmentUtilizationWidgetHeaderInfo";
import { WidgetCardHeaderEditButton } from "@/components/pages/dashboard/components/widgets/common/widget-header/components/WidgetCardHeaderEditButton";
import { CommitmentUtilizationWidgetHeaderTypeSelect } from "@/components/pages/dashboard/components/widgets/commitment-utlization/components/header/CommitmentUtilizationWidgetHeaderTypeSelect";
import { CommitmentUtilizationWidgetHeaderOrgIdSelect } from "@/components/pages/dashboard/components/widgets/commitment-utlization/components/header/CommitmentUtilizationWidgetHeaderOrgIdSelect";
import { CommitmentUtilizationWidgetHeaderGroupBySelect } from "@/components/pages/dashboard/components/widgets/commitment-utlization/components/header/CommitmentUtilizationWidgetHeaderGroupBySelect";
import { CommitmentUtilizationWidgetHeaderDateSelect } from "@/components/pages/dashboard/components/widgets/commitment-utlization/components/header/CommitmentUtilizationWidgetHeaderDateSelect";
import { CommitmentCloudProvider } from "@/services/cloudchipr.api";

interface CommitmentUtilizationWidgetCardSubHeaderProps
  extends CommitmentUtilizationWidgetHeaderInfoProps {
  widgetId?: string;
  provider?: CommitmentCloudProvider;
}

export const CommitmentUtilizationWidgetCardSubHeader: FC<
  CommitmentUtilizationWidgetCardSubHeaderProps
> = ({
  providerOrganisationId,
  commitmentType,
  grouping,
  dates,
  widgetId,
  provider,
}) => {
  return (
    <Stack direction="row" gap={1} alignItems="center" overflow="auto">
      {(providerOrganisationId || provider) && (
        <CommitmentUtilizationWidgetHeaderTypeSelect
          provider={provider}
          widgetId={widgetId}
          commitmentType={commitmentType}
          providerOrganisationId={providerOrganisationId}
        />
      )}

      {(providerOrganisationId || provider) && (
        <CommitmentUtilizationWidgetHeaderOrgIdSelect
          provider={provider}
          widgetId={widgetId}
          providerOrganisationId={providerOrganisationId}
        />
      )}

      {grouping && (
        <CommitmentUtilizationWidgetHeaderGroupBySelect
          widgetId={widgetId}
          grouping={grouping}
        />
      )}

      {dates && (
        <CommitmentUtilizationWidgetHeaderDateSelect
          dates={dates}
          widgetId={widgetId}
        />
      )}

      {widgetId && (
        <WidgetCardHeaderEditButton
          widgetId={widgetId}
          widgetType="commitments_utilization"
        />
      )}
    </Stack>
  );
};
